import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import socialIcon1 from '../Images/1.png';
import socialIcon2 from '../Images/2.png';
import socialIcon4 from '../Images/4.png';
import socialIcon5 from '../Images/5.png';

function TopHeader() {
    const marqueeRef = useRef(null);

    const handleMouseEnter = () => {
        if (marqueeRef.current) {
            marqueeRef.current.stop();
        }
    };

    const handleMouseLeave = () => {
        if (marqueeRef.current) {
            marqueeRef.current.start();
        }
    };

    return (
        <>
            <nav className="top-fixed" style={{ background: "#89c764" }}>
                <div className="container-fluid d-flex flex-wrap justify-content-between align-items-center">
                    <div className="marquee-wrapper flex-grow-1 me-lg-3" style={{ minWidth: "260px", overflow: "hidden" }}>
                        <marquee
                            behavior="alternate"
                            style={{ color: "#fff", fontFamily: "poppins", margin: 0, padding: "8px 0" }}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            ref={marqueeRef}
                        >
                            Still You can file Your ITR | Start Your Tax Saving Today:-  <Link to="/contact"><button className="rounded text-white border-0 top-header-btn" style={{ background: "#105985" }}>Click Here</button></Link>
                        </marquee>
                    </div>

                    <div className="d-flex justify-content-center align-items-center social-icons">
                        <div className="p-1">
                            <Link to="https://www.facebook.com/compliancekare/" target='_blank'>
                                <img src={socialIcon1} alt="Social_icon" style={{ width: "35px", height: "35px", cursor: "pointer" }} title='facebook' />
                            </Link>
                        </div>
                        <div className="p-1">
                            <Link to="https://www.instagram.com/compliancekare/" target='_blank'>
                                <img src={socialIcon5} alt="Social_icon" style={{ width: "35px", height: "35px", cursor: "pointer" }} title='Instagram' />
                            </Link>
                        </div>
                        <div className="p-1">
                            <Link to="https://twitter.com/compliancekare/" target='_blank'>
                                <img src={socialIcon4} alt="Social_icon" style={{ width: "35px", height: "35px", cursor: "pointer" }} title='twitter' />
                            </Link>
                        </div>
                        <div className="p-1">
                            <Link to="" target='_blank'>
                                <img src={socialIcon2} alt="Social_icon" style={{ width: "35px", height: "35px", cursor: "pointer" }} title='youtube' />
                            </Link>
                        </div>
                    </div>
                </div>
            </nav>

            <style dangerouslySetInnerHTML={{
                __html: `
                .top-header-btn {
                    padding: 4px 14px;
                    font-weight: 600;
                    font-size: 13px;
                    margin-left: 8px;
                    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
                    transition: all 0.3s ease;
                }
                .top-header-btn:hover {
                    background-color: #0b3753 !important;
                    transform: translateY(-1px);
                    box-shadow: 0 6px 14px rgba(0,0,0,0.15);
                }
                .social-icons img {
                    transition: all 0.3s ease;
                }
                .social-icons img:hover {
                    transform: scale(1.18) translateY(-2px);
                    filter: brightness(1.1);
                }
            `}} />
        </>
    );
}

export default TopHeader;
